import {Box, Typography, TypographyProps} from '@mui/material';
import {styled} from '@mui/material/styles';

export const UnitPrice = styled('span')(({theme}) => ({
  fontSize: theme.spacing(1.5),
  paddingLeft: theme.spacing(0.25),
  fontWeight: theme.typography.fontWeightMedium
}));

export const FavListDiscountWeightedFreshKgText = styled('span')(({theme}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.spacing(1.5),
  paddingLeft: theme.spacing(0.25)
}));

export const PriceStriked = styled(Typography)(({theme}) => ({
  lineHeight: theme.spacing(2.4),
  color: theme.palette.grey[300],
  textDecoration: 'line-through',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.spacing(1.5),
  '&.plp_v2': {
    fontSize: theme.spacing(1.25)
  },
  '&.search': {
    lineHeight: theme.spacing(2.1)
  },
  '&.searchKg': {
    lineHeight: theme.spacing(2)
  }
})) as typeof Typography;

export const PriceStrikedPDP = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: theme.spacing(3.25),
  fontSize: `${theme.spacing(2)} !important`,
  //lineHeight: theme.spacing(4.5),
  color: theme.palette.grey[300],
  textDecoration: 'line-through',
  '&.pdp_popup': {
    fontSize: `${theme.spacing(1.75)} !important`
  },
  '&.compact': {
    fontSize: `${theme.spacing(2)} !important`,
    [theme.breakpoints.down('sm')]: {
      fontSize: `${theme.spacing(1.75)} !important`
    }
  }
})) as typeof Typography;

export const PriceStrikedContainer = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex'
}));

export const PricePercentage = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: theme.spacing(3.25),
  fontSize: `${theme.spacing(2)} !important`,
  '&.pdp_popup': {
    fontSize: `${theme.spacing(1.75)} !important`
  }
})) as typeof Typography;

export const PriceStyled = styled(Typography)<TypographyProps & {isReactNativeView?: boolean}>(
  ({theme, isReactNativeView}) => ({
    fontWeight: isReactNativeView ? '700' : theme.typography.h2.fontWeight,
    fontSize: isReactNativeView ? '16px' : theme.typography.h6.fontSize,
    lineHeight: theme.typography.h6.lineHeight,
    '&.compact': {
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.spacing(1.75)
      }
    }
  })
);

export const PriceBox = styled(Box)(({theme}) => ({
  //marginTop: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(),
  '&.wrapAmount': {
    flexDirection: 'column',
    gap: 4,
    alignItems: 'flex-end'
  },
  '&.pdp_popup': {
    marginTop: 0
  },
  '&.fav': {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  '&.search': {
    display: 'flex',
    alignItems: 'flex-end'
  },
  [theme.breakpoints.down(420)]: {
    flexWrap: 'wrap'
  }
})) as typeof Box;

export const StyledSlabPriceInfo = styled(Box)(({theme}) => ({
  color: theme.palette.grey[900],
  fontWeight: theme.typography.fontWeightMedium,
  paddingBottom: theme.spacing(2),
  '&.pdp_popup': {
    color: theme.palette.grey[400],
    fontSize: theme.spacing(1.75),
    paddingBottom: 0
  },
  '&.plp_v2, &.search': {
    paddingBottom: theme.spacing(0.75),
    color: theme.palette.primary.main,
    fontSize: '12px',
    fontWeight: theme.typography.fontWeightBold
  },
  '&.search': {
    paddingBottom: theme.spacing(0.25)
  }
})) as typeof Box;

export const StyledDicountContainer = styled(Box)(({theme}) => ({
  '&.pdp_popup': {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing(1)
  },
  '&.plp_v2, &.search': {
    display: 'flex',
    flexDirection: 'column-reverse'
  }
}));

export const StyledDiscountBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  alignItems: 'center'
}));

export const StyledUnitPerProductInfo = styled(Box)(({theme}) => ({
  fontSize: theme.spacing(2),
  color: theme.palette.grey[400],
  paddingBottom: theme.spacing(1)
}));
